const YES_NO = {
  YES: [1, 'Có', 'blue'],
  NO: [0, 'Không', 'gray'],
};
export default YES_NO;
